import { Reducer } from 'redux';
import { ViewTvalActionTypes } from './actions';

interface IViewTvalState {
  data: any;
}

// Type-safe initialState!
const initialState: IViewTvalState = {
  data: null,
};

const reducer: Reducer<IViewTvalState> = (state = initialState, action) => {
  //console.log('action', action);
  switch (action.type) {
    case ViewTvalActionTypes.VIEW_TVAL_GET_FORM_DATA: {
      let _state = { ...state };
      _state = { ...state, data: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
